
// 引用axios
var axios = require('axios')

function apiAxios (method, url, params, name, failure) {
  let CancelToken = axios.CancelToken
  axios({
    method:method ,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    responseType: 'blob',
    withCredentials: false,
    cancelToken: new CancelToken(function executor(c) {
      window.Vue.cancel = c
    })
  })
  .then(function (res) {
    let blob = res.data
    let reader = new FileReader()
    reader.readAsDataURL(blob)
    reader.onload = (e) => {
      let a = document.createElement('a')
      a.download = name
      a.href = e.target.result
      document.body.appendChild(a)
      a.click()
      document.body.removeChild(a)
    }
  })
  .catch(function (err) {
    console.log(err)
  })
}
// 返回在vue模板中的调用接口
export default {
  export: function (method, url, params, name, failure) {
    return apiAxios (method, url, params,name, failure)
  }
}


// WEBPACK FOOTER //
// ./src/axios_api/exportFile.js